var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
// src/data/hooks/useCallFlows.ts
import { useRecoilState } from 'recoil';
import { callFlowsAtom } from '../store'; // you need to define callFlowsAtom in your recoil store
import { useRequest } from '../../hooks/useRequest';
export var useCallFlows = function () {
    var _a = useRecoilState(callFlowsAtom), callFlows = _a[0], setCallFlows = _a[1];
    var request = useRequest();
    var getAllCallFlows = function () { return __awaiter(void 0, void 0, void 0, function () {
        var data, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, request.get('/callflow')];
                case 1:
                    data = (_a.sent()).data;
                    setCallFlows(data);
                    return [2 /*return*/, data];
                case 2:
                    error_1 = _a.sent();
                    console.error(error_1);
                    throw error_1;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var getCallFlowById = function (callFlowId) { return __awaiter(void 0, void 0, void 0, function () {
        var data, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, request.get("/callflow/".concat(callFlowId))];
                case 1:
                    data = (_a.sent()).data;
                    return [2 /*return*/, data];
                case 2:
                    error_2 = _a.sent();
                    console.error(error_2);
                    throw error_2;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var createCallFlow = function (dto) { return __awaiter(void 0, void 0, void 0, function () {
        var data_1, error_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, request.post('/callflow', dto)];
                case 1:
                    data_1 = (_a.sent()).data;
                    // Optionally refresh the list or push the new item:
                    setCallFlows(function (prev) { return __spreadArray(__spreadArray([], prev, true), [data_1], false); });
                    return [2 /*return*/, data_1];
                case 2:
                    error_3 = _a.sent();
                    console.error(error_3);
                    throw error_3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var updateCallFlow = function (callFlowId, dto) { return __awaiter(void 0, void 0, void 0, function () {
        var data_2, error_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, request.put("/callflow/".concat(callFlowId), dto)];
                case 1:
                    data_2 = (_a.sent()).data;
                    // Optionally update local recoil state
                    setCallFlows(function (prev) { return prev.map(function (flow) { return (flow.id === callFlowId ? data_2 : flow); }); });
                    return [2 /*return*/, data_2];
                case 2:
                    error_4 = _a.sent();
                    console.error(error_4);
                    throw error_4;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var deleteCallFlow = function (callFlowId) { return __awaiter(void 0, void 0, void 0, function () {
        var error_5;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, request.delete("/callflow/".concat(callFlowId))];
                case 1:
                    _a.sent();
                    setCallFlows(function (prev) { return prev.filter(function (flow) { return flow.id !== callFlowId; }); });
                    return [3 /*break*/, 3];
                case 2:
                    error_5 = _a.sent();
                    console.error(error_5);
                    throw error_5;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    /** Assign phone numbers to a call flow */
    var assignPhoneNumbersToCallFlow = function (callFlowId, phoneNumberIds) { return __awaiter(void 0, void 0, void 0, function () {
        var error_6;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, request.put("/callflow/".concat(callFlowId, "/phone-numbers"), phoneNumberIds)];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 3];
                case 2:
                    error_6 = _a.sent();
                    console.error(error_6);
                    throw error_6;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    /** Get phone numbers that are not assigned to a specific call flow */
    var getNotAssignedPhoneNumbers = function () { return __awaiter(void 0, void 0, void 0, function () {
        var data, error_7;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, request.get("/callflow/unassigned-phone-numbers")];
                case 1:
                    data = (_a.sent()).data;
                    return [2 /*return*/, data];
                case 2:
                    error_7 = _a.sent();
                    console.error(error_7);
                    throw error_7;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var getAvailablePhoneNumbersForFlow = function (callFlowId) { return __awaiter(void 0, void 0, void 0, function () {
        var data, error_8;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, request.get("/callflow/".concat(callFlowId, "/unassigned-phone-numbers"))];
                case 1:
                    data = (_a.sent()).data;
                    return [2 /*return*/, data];
                case 2:
                    error_8 = _a.sent();
                    console.error(error_8);
                    throw error_8;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    return {
        callFlows: callFlows,
        getAllCallFlows: getAllCallFlows,
        getCallFlowById: getCallFlowById,
        createCallFlow: createCallFlow,
        updateCallFlow: updateCallFlow,
        deleteCallFlow: deleteCallFlow,
        assignPhoneNumbersToCallFlow: assignPhoneNumbersToCallFlow,
        getNotAssignedPhoneNumbers: getNotAssignedPhoneNumbers,
        getAvailablePhoneNumbersForFlow: getAvailablePhoneNumbersForFlow
    };
};
